import { render, staticRenderFns } from "./templateWeight.vue?vue&type=template&id=99acae7c&scoped=true"
import script from "./templateWeight.vue?vue&type=script&lang=js"
export * from "./templateWeight.vue?vue&type=script&lang=js"
import style0 from "./templateWeight.vue?vue&type=style&index=0&id=99acae7c&prod&lang=css"
import style1 from "./templateWeight.vue?vue&type=style&index=1&id=99acae7c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99acae7c",
  null
  
)

export default component.exports